import React from "react"
import { LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface EmptyStateProps {
  /** Lucide icon component to render (e.g. Package, ShoppingCart) */
  icon: LucideIcon
  /** Primary message text rendered in Bebas Neue */
  message: string
  /** Optional slot for an action button or link below the message */
  action?: React.ReactNode
  className?: string
}

/**
 * Standard empty/zero-state placeholder used throughout the app.
 * Renders a faded icon + message in the industrial dashed-border container.
 *
 * @example
 * <EmptyState
 *   icon={Package}
 *   message="No items found"
 *   action={<Button variant="outline">Add Product</Button>}
 * />
 */
export function EmptyState({ icon: Icon, message, action, className }: EmptyStateProps) {
  return (
    <div className={cn("empty-state py-32", className)}>
      <Icon className="mx-auto mb-6 h-16 w-16 text-muted-foreground opacity-10" />
      <p className="font-display text-3xl tracking-widest text-muted-foreground opacity-20">
        {message}
      </p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}

